import { HttpMethods, makeRequest } from '../helpers/http.helper';
import { CreateContactRequest } from '../types/contact.type';

export const submitContactRequest = (data: CreateContactRequest) => {
  return makeRequest({
    url: '/contact',
    method: HttpMethods.POST,
    data,
  });
};
